import type { Attempt } from './round.ts';

export type AttemptComparison = 'a' | 'b' | 'tie';

/** Lower absolute error wins. Equal error is a tie and awards no round point. */
export function compareAttempts(a: Attempt, b: Attempt): AttemptComparison {
  if (a.errorMs < b.errorMs) return 'a';
  if (b.errorMs < a.errorMs) return 'b';
  return 'tie';
}
